import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

export const SubmitButtonStyle = styled.div`
  width: 100%;

  .submit-element {
    ${fontFamily.sourceSansPro.bold}
    border-radius: 8px;
    color: ${colors.white};
    display: block;
    font-size: 14px;
    line-height: 34px;
    padding: 8px 16px;
    text-transform: uppercase;
    width: 100%;

    &.cancel-theme {
      background-color: ${colors.brightRed};
    }

    &.default-theme {
      background-color: ${colors.limeGreen};
    }
  }

  .submit-error {
    ${fontFamily.InputFieldStyle};
    color: #ff00ff;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 4px;
  }
`;
